import externalLink from './externalLink'

export default function locationAsHtml({
    location = '',
    locationLink = '',
}): string {
    if (location && locationLink) {
        return `${location}: ${externalLink(locationLink)}`
    }

    if (location) {
        return location
    }

    if (locationLink) {
        return externalLink(locationLink)
    }

    return ''
}
